import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export default function ContactTab() {
  const [phone, setPhone] = useState('+91 73975 47474');
  const [email, setEmail] = useState('zionaog.fernhill@gmail.com');
  const [phoneEnabled, setPhoneEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    supabase.from('church_settings').select('key,value').then(({ data }) => {
      if (data) {
        data.forEach(r => {
          if (r.key === 'church_phone')         setPhone(r.value || '+91 73975 47474');
          if (r.key === 'church_email')         setEmail(r.value || 'zionaog.fernhill@gmail.com');
          if (r.key === 'church_phone_enabled') setPhoneEnabled(r.value !== 'false');
          if (r.key === 'church_email_enabled') setEmailEnabled(r.value !== 'false');
        });
      }
    });
  }, []);

  const save = async () => {
    setSaving(true);
    const upsertOpts = { onConflict: 'key' };
    const results = await Promise.all([
      supabase.from('church_settings').upsert({ key:'church_phone',         value: phone },         upsertOpts),
      supabase.from('church_settings').upsert({ key:'church_email',         value: email },         upsertOpts),
      supabase.from('church_settings').upsert({ key:'church_phone_enabled', value: String(phoneEnabled) }, upsertOpts),
      supabase.from('church_settings').upsert({ key:'church_email_enabled', value: String(emailEnabled) }, upsertOpts),
    ]);
    setSaving(false);
    const hasError = results.some(r => r.error);
    if (hasError) {
      setMsg('❌ Save failed — make sure you ran church_settings_setup.sql in Supabase first!');
    } else {
      setMsg('✅ Saved! Refresh the website to see changes.');
    }
    setTimeout(() => setMsg(''), 5000);
  };

  const css = {
    card: { background:'#fff', border:'1px solid #e8d8b0', borderRadius:14, padding:'24px', marginBottom:16, boxShadow:'0 2px 8px rgba(0,0,0,0.05)' },
    label: { display:'block', fontSize:'0.66rem', letterSpacing:'0.12em', textTransform:'uppercase', color:'#8b6508', marginBottom:6, fontWeight:700 },
    input: { width:'100%', padding:'12px 16px', background:'#fdf8f0', border:'1.5px solid #d4b896', borderRadius:9, color:'#1a2a4a', fontSize:'0.92rem', outline:'none', fontFamily:"'Raleway',sans-serif" },
    btn: { background:'linear-gradient(135deg,#c9a84c,#8b6914)', border:'none', color:'#070f22', fontFamily:"'Raleway',sans-serif", fontWeight:700, fontSize:'0.82rem', padding:'12px 28px', borderRadius:9, cursor:'pointer', letterSpacing:'0.1em' },
    row: { display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12, marginBottom:14 },
  };

  const Toggle = ({ enabled, onToggle, label, color='#5cb85c' }) => (
    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
      <span style={{ fontSize:'0.76rem', color: enabled ? '#1d5c1d' : '#8b0000', fontWeight:700 }}>
        {enabled ? '● Visible on website' : '● Hidden from website'}
      </span>
      <div onClick={onToggle} style={{
        width:50, height:28, borderRadius:14,
        background: enabled ? color : '#ccc',
        position:'relative', cursor:'pointer', transition:'background 0.25s', flexShrink:0,
      }}>
        <div style={{
          position:'absolute', top:4, left: enabled ? 26 : 4,
          width:20, height:20, borderRadius:'50%',
          background:'#fff', transition:'left 0.25s',
          boxShadow:'0 2px 4px rgba(0,0,0,0.2)',
        }} />
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ background:'rgba(184,134,11,0.08)', border:'1px solid #d4b896', borderRadius:10, padding:'12px 16px', marginBottom:20, fontSize:'0.82rem', color:'#5a4e3e', lineHeight:1.6 }}>
        📞 <strong style={{color:'#8b6508'}}>Church Contact Details:</strong> Update phone number and email. Toggle visibility to show or hide them on the website.
      </div>

      {msg && (
        <div style={{ background:'#f0fff0', border:'1px solid #5cb85c', borderRadius:8, padding:'10px 16px', marginBottom:16, color:'#1d5c1d', fontSize:'0.85rem' }}>
          {msg}
        </div>
      )}

      <div style={css.card}>
        {/* Phone */}
        <div style={{ marginBottom:20 }}>
          <div style={css.row}>
            <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.88rem', color:'#8b6508' }}>📞 Phone Number</div>
            <Toggle enabled={phoneEnabled} onToggle={() => setPhoneEnabled(v => !v)} />
          </div>
          <label style={css.label}>Phone Number</label>
          <input
            style={{ ...css.input, opacity: phoneEnabled ? 1 : 0.5 }}
            value={phone}
            onChange={e => setPhone(e.target.value)}
            placeholder="+91 73975 47474"
            disabled={!phoneEnabled}
          />
          {!phoneEnabled && (
            <div style={{ fontSize:'0.72rem', color:'#8b0000', marginTop:4 }}>
              ⚠️ Phone number is hidden from website visitors
            </div>
          )}
        </div>

        {/* Divider */}
        <div style={{ height:1, background:'linear-gradient(90deg,transparent,#e8d8b0,transparent)', margin:'4px 0 20px' }} />

        {/* Email */}
        <div>
          <div style={css.row}>
            <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.88rem', color:'#8b6508' }}>📧 Email Address</div>
            <Toggle enabled={emailEnabled} onToggle={() => setEmailEnabled(v => !v)} color='#1877f2' />
          </div>
          <label style={css.label}>Email Address</label>
          <input
            style={{ ...css.input, opacity: emailEnabled ? 1 : 0.5 }}
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="zionaog.fernhill@gmail.com"
            disabled={!emailEnabled}
          />
          {!emailEnabled && (
            <div style={{ fontSize:'0.72rem', color:'#8b0000', marginTop:4 }}>
              ⚠️ Email is hidden from website visitors
            </div>
          )}
        </div>

        <div style={{ marginTop:22 }}>
          <button onClick={save} disabled={saving} style={{ ...css.btn, opacity: saving ? 0.7 : 1 }}>
            {saving ? '⏳ Saving…' : '💾 Save Contact Details'}
          </button>
        </div>
      </div>

      <div style={{ background:'#fff8e7', border:'1px solid #e8d8b0', borderRadius:12, padding:'16px 20px', fontSize:'0.78rem', color:'#6b5e4e', lineHeight:1.8 }}>
        <strong style={{ color:'#8b6508' }}>💡 Where these appear on website:</strong><br/>
        📞 Phone → Navbar call button, Footer, Connect section, WhatsApp link<br/>
        📧 Email → Footer, Connect section<br/>
        Toggle OFF to hide from public view while keeping the number saved.
      </div>
    </div>
  );
}
